import React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import { Box, Typography } from "@mui/material";

const HeaderModal = (
  { modalDescription,
    children,
    component,
    buttonsArr = [],
    closeIcon,
    text,
    startIcon,
    navigation,
    disabled = false,
    setShow,
    color,
    endIcon,
    variant,
    show,
    noButton,
    resetModalFields,
    resetFormSteps
  }
) => {

  const handleClickOpen = () => {
    setShow(true);
  };

  const handleClose = (e) => {
    resetFormSteps?.();
    resetModalFields?.();
    setShow(false);
  };

  return (
    <>
      {
        noButton ? null : <Button
          onClick={handleClickOpen}
          disabled={disabled}
          startIcon={startIcon && startIcon}
          endIcon={endIcon && endIcon}
          sx={{
            borderRadius: "8px",
            paddingY: "8px",
            paddingX: "12px",
            fontSize: "14px",
            fontWeight: "600",
            textTransform: "none",
            "&.Mui-disabled": {
              opacity: "0.3",
              backgroundColor: "primary.main",
              color: "white",
            },
          }}
          variant={variant && variant}
          color={color ? color : "primary"}
          disableElevation
          disableFocusRipple
          disableRipple
        >
          {text}
        </Button>
      }

      <Dialog
        open={show}
        fullWidth
        maxWidth={'sm'}

        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          zIndex: '10005',
          "& .MuiDialog-paper": {
            px: "1.2em",
            py: "1em",
            borderRadius: "8px",
            minHeight: '27rem',
          },
        }}
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{
            fontSize: "18px",
            fontWeight: 500,
            color: "grey.dark",
            marginBottom: "1em",
            justifyContent: "space-between",
            display: "flex",
            "& svg": {
              padding: "0",
            },
          }}
        >
          <Typography
            variant="h4"
            component={"h4"}
            fontWeight={500}
            lineHeight={"24px"}
            display="flex"
            justifyContent={"center"}
            alignItems={"center"}
          >
            {modalDescription && modalDescription}
          </Typography>
          {navigation && navigation}
          {closeIcon && (
            <IconButton
              aria-label="close"
              size="large"
              sx={{ fontSize: "1.4rem" }}
              onClick={handleClose}
            >
              <ClearRoundedIcon fontSize="inherit" />
            </IconButton>
          )}
        </DialogTitle>
        <DialogContent>{children}</DialogContent>
      </Dialog>
    </>
  );
};

export default HeaderModal;
